import { render } from "./OperationsModal.vue?vue&type=template&id=97ecd564"
import script from "./OperationsModal.vue?vue&type=script&lang=js"
export * from "./OperationsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__